import type { ChainData } from "@0xsquid/squid-types";
import { ChainType } from "@0xsquid/squid-types";
import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { keys } from "../../core/queries/queries-keys";
import {
  getCosmosKey,
  suggestChainOrThrow,
} from "../../services/internal/cosmosService";
import { useCosmosSigner } from "./useCosmos";

export const useCosmosForChain = (
  chain: ChainData | undefined
): UseQueryResult<string, unknown> => {
  const { keplrTypeWallet } = useCosmosSigner({ chain });

  const cosmosAddressQuery = useQuery(
    keys().cosmosAddress(chain?.chainId),
    async () => {
      if (!chain || !keplrTypeWallet) return "";

      try {
        const address = await getCosmosKey(chain.chainId, keplrTypeWallet);

        return address ?? "";
      } catch (error) {
        await suggestChainOrThrow({
          chain: chain,
          error,
          keplrTypeWallet,
        });

        const address = await getCosmosKey(chain.chainId, keplrTypeWallet);

        return address ?? "";
      }
    },
    {
      enabled: !!keplrTypeWallet && chain?.chainType === ChainType.COSMOS,
    }
  );

  return cosmosAddressQuery;
};
